import { Button, BUTTON_TYPES } from 'components/Button'
import { Typography, TYPOGRAPHY_WEIGHT } from 'components/Typography'
import { ReactComponent as Plus16 } from 'assets/svg/Plus16.svg'
import './styles.scss'

type TiersEmptyStateProps = {
  onAdd: () => void
  canAddTiers: boolean
}

const TiersEmptyState = ({ onAdd, canAddTiers }: TiersEmptyStateProps) => (
  <div className="tiers-empty-state column">
    <Typography.Body1 weight={TYPOGRAPHY_WEIGHT.SEMI_BOLD}>
      No added tiers
    </Typography.Body1>
    {canAddTiers && (
      <>
        <Typography.Body1>
          Add up to 15 tiers to set the rebate % for each market share
          threshold.
        </Typography.Body1>
        <Button
          className="tiers-empty-state__add-btn"
          type={BUTTON_TYPES.GHOST}
          icon={<Plus16 />}
          upperCase
          htmlType="button"
          onClick={onAdd}
        >
          Add tier
        </Button>
      </>
    )}
  </div>
)

export default TiersEmptyState
